import { Col, Nav, NavLink } from "reactstrap";
import { Href } from "../../../../../constants";
import { OrganizationLists } from "../../../../../data/applications/Contacts";
import { OrganizationProps } from "../../../../../types/Applications";
import { dynamicImage } from "../../../../../utils";
import { Image } from "../../../../../coreComponents/Image";

const OrganizationList: React.FC<OrganizationProps> = ({ orgActiveTab, setOrgActiveTab }) => {

  return (
    <Col xl="4" md="5" className="xl-50">
      <Nav className="flex-column" pills>
        {OrganizationLists.map((item) => (
          <NavLink key={item.id} href={Href} className={orgActiveTab === item.id ? "active" : ""} onClick={() => setOrgActiveTab(item.id)}>
            <div className="d-flex">
              <Image className="img-50 img-fluid m-r-20 rounded-circle" src={dynamicImage(`${item.avatar}`)} alt="" />
              <div className="flex-grow-1">
                <h6>{item.name}</h6>
                <p>{item.email}</p>
              </div>
            </div>
          </NavLink>
        ))}
      </Nav>
    </Col>
  );
};

export default OrganizationList;